import { ref } from 'vue';

const isInitialized = ref(false);

const TOP_SAFE_AREA = 'var(--safe-area-inset-top, env(safe-area-inset-top, 0px))';
const BOTTOM_SAFE_AREA = 'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))';
const LEFT_SAFE_AREA = 'var(--safe-area-inset-left, env(safe-area-inset-left, 0px))';
const RIGHT_SAFE_AREA = 'var(--safe-area-inset-right, env(safe-area-inset-right, 0px))';

export function useSafeArea() {
  // SystemBars and CSS env() update automatically when the window insets
  // change, so no native listener or manual CSS injection is needed.
  function initSafeArea() {
    isInitialized.value = true;
  }

  // Layout constants (in pixels)
  const HEADER_HEIGHT = 96; // 6rem = 96px
  const NAVBAR_HEIGHT = 64; // 4rem = 64px

  const topSafeArea = TOP_SAFE_AREA;
  const bottomSafeArea = BOTTOM_SAFE_AREA;
  const leftSafeArea = LEFT_SAFE_AREA;
  const rightSafeArea = RIGHT_SAFE_AREA;

  const topSpace = `calc(${HEADER_HEIGHT}px + ${topSafeArea})`;
  const bottomSpace = `calc(${NAVBAR_HEIGHT}px + ${bottomSafeArea})`;

  const fixedBottomStyle = {
    bottom: bottomSpace,
  };

  const fixedTopStyle = {
    top: topSpace,
  };

  const contentPaddingBottom = {
    paddingBottom: bottomSpace,
  };

  return {
    // Initialization
    initSafeArea,
    isInitialized,

    // CSS inset values
    topSafeArea,
    bottomSafeArea,
    leftSafeArea,
    rightSafeArea,

    // Computed spaces
    topSpace,
    bottomSpace,

    // Helper classes and styles
    fixedBottomStyle,
    fixedTopStyle,
    contentPaddingBottom,

    // Constants
    HEADER_HEIGHT,
    NAVBAR_HEIGHT,
  };
}
